(function () {
  const DEFAULT_LEGS = [
    { id: "L1", name: "Leg 1", subtitle: "Atlantic Coast", stages: ["Tors Cove", "Burnt Cove", "Bauline East"] },
    { id: "L2", name: "Leg 2", subtitle: "Placentia Bay", stages: ["Mt Carmel", "N. Harbour", "Branch", "Pt Lance", "C. St Mary's", "St Bride's", "Pt Verde"] },
    { id: "L3", name: "Leg 3", subtitle: "Eastport", stages: ["Pt Blandford", "Happy Adv.", "Salvage", "Eastport"] },
    { id: "L4", name: "Leg 4", subtitle: "", stages: ["SS4-1", "SS4-2"] },
    { id: "L5", name: "Leg 5", subtitle: "", stages: ["SS5-1", "SS5-2"] },
    { id: "L6", name: "Leg 6", subtitle: "Brigus", stages: ["Brigus 1", "Brigus 2", "Brigus 3"] }
  ];

  const SEED = {
    event: "Targa Newfoundland Duemila",
    asOf: "Sample data · replace JSON in the section",
    legs: DEFAULT_LEGS,
    divisions: {
      "Targa 2": [
        { car: 201, crew: "Pollard / Boehner", vehicle: "2006 MINI JCW", cls: "M2WD", trophy: true, status: "running",
          legs: [[0,2,0],[1,0,2,0,1,0,1],[0,4,1,5],[],[],[]],
          raw: [[492,431,388],[918,2710,310,642,758,2374,180],[301,148,689,690],[],[],[]] },
        { car: 269, crew: "Mason / Mason", vehicle: "1968 Volvo 122S", cls: "C2WD", trophy: true, status: "running",
          legs: [[3,1,6],[2,2,3,1,2,1,2],[2,8,4,2],[],[],[]],
          raw: [[510,428,401],[940,2744,322,655,771,2390,188],[312,162,702,678],[],[],[]] },
        { car: 200, crew: "Maxwell / Gatehouse", vehicle: "2008 Evo X", cls: "MAWD", trophy: true, status: "dnf",
          legs: [[1,5,2],[3,2,4,2,3,2,3],[3,7,3,9],[],[],[]],
          raw: [[498,445,395],[933,2730,318,661,780,2388,186],[315,159,"DNF",null],[],[],[]] }
      ],
      "Targa 1": [
        { car: 144, crew: "Pobst / Abbott", vehicle: "2013 MINI GP", cls: "M2WD", trophy: true, status: "running",
          legs: [[1,0,2],[1,1,2,0,1,1,1],[1,3,1,4],[],[],[]],
          raw: [[501,422,396],[925,2722,314,640,762,2380,182],[306,152,691,688],[],[],[]] },
        { car: 153, crew: "Knight / King-Gaudon", vehicle: "2015 Mustang GT", cls: "M2WD", trophy: true, status: "running",
          legs: [[2,3,1],[2,2,2,1,2,1,2],[2,5,2,6],[],[],[]],
          raw: [[508,440,390],[938,2738,316,651,770,2386,187],[310,156,698,702],[],[],[]] }
      ],
      "Grand Tour": [
        { car: 302, crew: "Damm / Damm", vehicle: "BMW 328xiT", cls: "M2WD", trophy: true, status: "running",
          legs: [[0,1,0],[0,0,1,0,0,1,0],[0,1,0,1],[],[],[]],
          raw: [[505,429,387],[922,2718,312,644,760,2378,179],[304,150,686,685],[],[],[]] }
      ]
    }
  };

  function carCount(data) {
    if (!data || !data.divisions) return 0;
    return Object.keys(data.divisions).reduce(function (n, k) {
      return n + (data.divisions[k] || []).length;
    }, 0);
  }

  function parseBlock(el) {
    if (!el) return null;
    var text = (el.textContent || "").trim();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (err) {
      console.warn("Targa standings: JSON parse failed", err);
      return null;
    }
  }

  function parseTime(v) {
    if (v == null || v === "") return null;
    if (String(v).toUpperCase() === "DNF") return "DNF";
    if (typeof v === "number" && !isNaN(v)) return v;
    var s = String(v).trim();
    if (!s) return null;
    if (/^\d+(\.\d+)?$/.test(s)) return Number(s);
    var m = s.match(/^(\d+):(\d{1,2})(?:\.(\d+))?$/);
    if (m) return Number(m[1]) * 60 + Number(m[2]) + (m[3] ? Number("0." + m[3]) : 0);
    return null;
  }

  function fmtPen(sec) {
    if (sec == null || isNaN(sec)) return "—";
    var n = Math.round(Number(sec));
    var m = Math.floor(n / 60);
    var s = String(n % 60).padStart(2, "0");
    return m ? m + ":" + s : "0:" + s;
  }

  function fmtRaw(sec) {
    if (sec == null || sec === "") return "—";
    if (String(sec).toUpperCase() === "DNF") return "DNF";
    var n = Number(sec);
    if (isNaN(n)) return String(sec);
    var sign = n < 0 ? "-" : "";
    n = Math.abs(n);
    var m = Math.floor(n / 60);
    var whole = Math.floor(n % 60);
    var frac = Math.round((n - Math.floor(n)) * 10);
    if (frac === 10) { whole += 1; frac = 0; }
    if (whole === 60) { m += 1; whole = 0; }
    return sign + m + ":" + String(whole).padStart(2, "0") + "." + frac;
  }

  function heatPen(sec) {
    if (sec === 0) return "rgba(62,207,142,.28)";
    if (sec <= 3) return "rgba(58,160,200,.28)";
    if (sec <= 8) return "rgba(240,162,2,.32)";
    return "rgba(227,93,93,.38)";
  }

  function heatRaw(sec, best) {
    if (sec == null || isNaN(sec) || best == null) return "rgba(255,255,255,.06)";
    var gap = sec - best;
    if (gap <= 0.05) return "rgba(62,207,142,.32)";
    if (gap <= 3) return "rgba(58,160,200,.28)";
    if (gap <= 10) return "rgba(240,162,2,.32)";
    return "rgba(227,93,93,.38)";
  }

  function init(root) {
    if (!root || root.getAttribute("data-targa-ready")) return;
    root.setAttribute("data-targa-ready", "1");

    var DATA = JSON.parse(JSON.stringify(SEED));
    var selected = null;
    var view = "both";
    var $ = function (id) { return root.querySelector("#" + id); };

    var parsed = parseBlock(root.querySelector("script.targa-data"));
    if (parsed && parsed.divisions && carCount(parsed) > 0) {
      if (!parsed.legs || !parsed.legs.length) parsed.legs = DEFAULT_LEGS;
      DATA = parsed;
    }

    function layout() {
      return DATA.legs && DATA.legs.length ? DATA.legs : DEFAULT_LEGS;
    }
    function carLegs(r) {
      if (Array.isArray(r.legs)) return layout().map(function (leg, i) { return r.legs[i] || []; });
      return layout().map(function () { return []; });
    }
    function carRaw(r) {
      if (Array.isArray(r.raw)) return layout().map(function (leg, i) { return r.raw[i] || []; });
      return layout().map(function () { return []; });
    }
    function isOut(r) {
      var s = String(r.status || "running").toLowerCase();
      return s === "dnf" || s === "retired" || s === "dns" || s === "ret";
    }
    function hasAnyRaw(list) {
      return (list || []).some(function (r) {
        return Array.isArray(r.raw) && r.raw.some(function (arr) {
          return (arr || []).some(function (v) { return v != null && v !== ""; });
        });
      });
    }
    function enrich(list) {
      var rows = (list || []).map(function (r) {
        var legs = carLegs(r);
        var raw = carRaw(r);
        var legTot = legs.map(function (arr) {
          return arr.reduce(function (a, b) {
            if (b == null || b === "" || String(b).toUpperCase() === "DNF") return a;
            return a + (Number(b) || 0);
          }, 0);
        });
        var rawLeg = raw.map(function (arr) {
          return arr.reduce(function (a, b) {
            var t = parseTime(b);
            if (t == null || t === "DNF") return a;
            return a + t;
          }, 0);
        });
        var total = legTot.reduce(function (a, b) { return a + b; }, 0);
        var rawTotal = rawLeg.reduce(function (a, b) { return a + b; }, 0);
        var cum = [];
        legTot.reduce(function (acc, v, i) { cum[i] = acc + v; return cum[i]; }, 0);
        var out = isOut(r);
        return Object.assign({}, r, {
          legs: legs, raw: raw, legTot: legTot, rawLeg: rawLeg,
          total: total, rawTotal: rawTotal, cum: cum, out: out,
          status: out ? String(r.status).toLowerCase() : "running"
        });
      });
      var live = rows.filter(function (r) { return !r.out; }).sort(function (a, b) { return a.total - b.total; })
        .map(function (r, i) { return Object.assign({}, r, { pos: i + 1 }); });
      var dead = rows.filter(function (r) { return r.out; }).sort(function (a, b) { return a.car - b.car; })
        .map(function (r) { return Object.assign({}, r, { pos: null }); });
      return live.concat(dead);
    }
    function currentList() {
      var divEl = $("targa-division");
      var clsEl = $("targa-cls");
      var qEl = $("targa-q");
      var div = divEl ? divEl.value : Object.keys(DATA.divisions)[0];
      var cls = clsEl ? clsEl.value : "";
      var q = qEl ? qEl.value.toLowerCase() : "";
      return enrich(DATA.divisions[div] || []).filter(function (r) {
        if (cls && r.cls !== cls) return false;
        if (!q) return true;
        return (r.car + " " + r.crew + " " + r.vehicle + " " + r.cls).toLowerCase().indexOf(q) !== -1;
      });
    }
    function bestRawMap(rows) {
      var map = {};
      rows.forEach(function (r) {
        if (r.out) return;
        r.raw.forEach(function (arr, li) {
          arr.forEach(function (v, si) {
            var t = parseTime(v);
            if (t == null || t === "DNF") return;
            var key = li + ":" + si;
            if (map[key] == null || t < map[key]) map[key] = t;
          });
        });
      });
      return map;
    }
    function stageCell(pen, rawVal, best) {
      var dnfPen = String(pen).toUpperCase() === "DNF";
      var parsed = parseTime(rawVal);
      var dnfRaw = parsed === "DNF" || dnfPen;
      if (dnfRaw) return '<td><span class="chip out">DNF</span></td>';

      var showPen = view === "pen" || view === "both";
      var showRaw = view === "raw" || view === "both";
      var emptyPen = pen == null || pen === "";
      var emptyRaw = parsed == null;

      if (showRaw && !showPen) {
        if (emptyRaw) return '<td class="sub">·</td>';
        return '<td><span class="heat" style="background:' + heatRaw(parsed, best) + '">' + fmtRaw(parsed) + "</span></td>";
      }
      if (showPen && !showRaw) {
        if (emptyPen) return '<td class="sub">·</td>';
        return '<td><span class="heat" style="background:' + heatPen(Number(pen)) + '">' + pen + "</span></td>";
      }
      if (emptyPen && emptyRaw) return '<td class="sub">·</td>';
      var rawHtml = emptyRaw ? '<span class="sub">—</span>' : '<span class="heat rawt" style="background:' + heatRaw(parsed, best) + '">' + fmtRaw(parsed) + "</span>";
      var penHtml = emptyPen ? "" : '<span class="pen">' + (Number(pen) === 0 ? "0" : "+" + pen) + "</span>";
      return '<td><div class="stack">' + rawHtml + penHtml + "</div></td>";
    }
    function renderBoard() {
      var rows = currentList();
      var leader = (rows.find(function (r) { return !r.out; }) || {}).total || 0;
      var rawLeader = (rows.find(function (r) { return !r.out; }) || {}).rawTotal || 0;
      var best = bestRawMap(rows);
      var legs = layout();
      var showRaw = view === "raw" || view === "both";
      var showPen = view === "pen" || view === "both";
      var top = '<th class="sticky" rowspan="2">Pos</th><th rowspan="2">Car</th><th rowspan="2">Crew</th><th rowspan="2">Class</th>' +
        legs.map(function (leg, i) {
          return '<th class="' + (i % 2 ? "leg-alt" : "leg") + '" colspan="' + (leg.stages.length + 1) + '">' +
            leg.name + (leg.subtitle ? " · " + leg.subtitle : "") + "</th>";
        }).join("") +
        '<th rowspan="2">Event</th><th rowspan="2">Gap</th><th rowspan="2"></th>';
      var sub = legs.map(function (leg) {
        return leg.stages.map(function (s) { return "<th>" + s + "</th>"; }).join("") + '<th class="tot">Leg</th>';
      }).join("");
      var body = rows.map(function (r) {
        var cells = r.legs.map(function (arr, li) {
          var names = legs[li].stages;
          var stageCells = names.map(function (_, si) {
            return stageCell(arr[si], (r.raw[li] || [])[si], best[li + ":" + si]);
          }).join("");
          var legLabel;
          if (showRaw && showPen) {
            legLabel = "<strong>" + (r.rawLeg[li] ? fmtRaw(r.rawLeg[li]) : "—") + "</strong><div class=\"pen\">" + fmtPen(r.legTot[li]) + "</div>";
          } else if (showRaw) {
            legLabel = "<strong>" + (r.rawLeg[li] ? fmtRaw(r.rawLeg[li]) : "—") + "</strong>";
          } else {
            legLabel = "<strong>" + fmtPen(r.legTot[li]) + "</strong>";
          }
          return stageCells + "<td>" + legLabel + "</td>";
        }).join("");
        var eventCell, gapCell;
        if (showRaw && !showPen) {
          eventCell = "<strong>" + (r.rawTotal ? fmtRaw(r.rawTotal) : "—") + "</strong>";
          gapCell = (r.out || r.pos === 1 || !r.rawTotal) ? "—" : "+" + fmtRaw(r.rawTotal - rawLeader);
        } else {
          eventCell = "<strong>" + fmtPen(r.total) + "</strong>" + (showRaw && r.rawTotal ? '<div class="sub">' + fmtRaw(r.rawTotal) + "</div>" : "");
          gapCell = (r.out || r.pos === 1 ? "—" : "+" + fmtPen(r.total - leader));
        }
        return '<tr data-car="' + r.car + '" class="' + (selected === r.car ? "selected" : "") + (r.out ? " out" : "") + '">' +
          '<td class="sticky pos ' + (r.pos === 1 ? "p1" : "") + '">' + (r.out ? (r.status || "dnf").toUpperCase() : r.pos) + "</td>" +
          '<td class="carno">' + r.car + "</td>" +
          '<td><div class="crew">' + r.crew + '</div><div class="sub">' + r.vehicle + "</div></td>" +
          '<td><span class="chip">' + r.cls + "</span></td>" +
          cells +
          "<td>" + eventCell + "</td>" +
          "<td>" + gapCell + "</td>" +
          "<td>" + (r.out ? '<span class="chip out">' + (r.status || "dnf").toUpperCase() + "</span>" : (r.trophy ? '<span class="chip trophy">Trophy</span>' : "")) + "</td>" +
          "</tr>";
      }).join("");
      var board = $("targa-board");
      if (!board) return;
      board.innerHTML = "<thead><tr>" + top + "</tr><tr>" + sub + "</tr></thead><tbody>" + body + "</tbody>";
      board.querySelectorAll("tr[data-car]").forEach(function (tr) {
        tr.onclick = function () { selected = Number(tr.getAttribute("data-car")); render(); };
      });
    }
    function renderDetail() {
      var box = $("targa-detail");
      if (!box) return;
      var divEl = $("targa-division");
      var rows = enrich(DATA.divisions[divEl ? divEl.value : Object.keys(DATA.divisions)[0]] || []);
      var r = rows.find(function (x) { return x.car === selected; });
      if (!r) { box.innerHTML = '<div class="empty">Click a row.</div>'; return; }
      var leader = (rows.find(function (x) { return !x.out; }) || rows[0] || {}).total || 0;
      var rawBits = r.rawTotal ? "<br>Raw " + fmtRaw(r.rawTotal) : "";
      box.innerHTML = '<div class="drawer-meta"><div class="sub">Car ' + r.car + " · " + (r.out ? (r.status || "dnf").toUpperCase() : "P" + r.pos) + " · " + r.cls + "</div>" +
        '<div class="crew" style="font-size:18px;margin:4px 0">' + r.crew + "</div>" +
        '<div class="sub">' + r.vehicle + "</div>" +
        '<p style="margin:10px 0 6px">Penalty ' + fmtPen(r.total) + " · Gap " + (r.out || r.pos === 1 ? "—" : "+" + fmtPen(r.total - leader)) + rawBits + "</p>" +
        '<canvas class="targa-spark"></canvas></div>';
      var c = box.querySelector(".targa-spark");
      if (!c) return;
      var ctx = c.getContext("2d");
      var w = c.width = c.parentElement.clientWidth - 4;
      var h = c.height = 86;
      var cum = r.cum || [0];
      var max = Math.max.apply(null, cum.concat([1]));
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = "#e10600";
      ctx.lineWidth = 2;
      ctx.beginPath();
      cum.forEach(function (v, i) {
        var x = 8 + i * ((w - 16) / (cum.length - 1 || 1));
        var y = h - 10 - (v / max) * (h - 24);
        i ? ctx.lineTo(x, y) : ctx.moveTo(x, y);
      });
      ctx.stroke();
    }
    function renderStats() {
      var box = $("targa-stats");
      if (!box) return;
      var divEl = $("targa-division");
      var rows = enrich(DATA.divisions[divEl ? divEl.value : Object.keys(DATA.divisions)[0]] || []);
      var classified = rows.filter(function (r) { return !r.out; }).length;
      var trophies = rows.filter(function (r) { return r.trophy && !r.out; }).length;
      var leader = rows.find(function (r) { return !r.out; });
      var nums = [];
      rows.forEach(function (r) {
        r.legs.forEach(function (arr) {
          arr.forEach(function (n) { if (!isNaN(Number(n))) nums.push(Number(n)); });
        });
      });
      var blow = nums.length ? Math.max.apply(null, nums) : 0;
      box.innerHTML =
        '<div class="stat"><b>' + classified + "</b><span>Classified</span></div>" +
        '<div class="stat"><b>' + trophies + "</b><span>Still on trophy pace</span></div>" +
        '<div class="stat"><b>' + fmtPen(leader ? leader.total : 0) + "</b><span>Leader penalty</span></div>" +
        '<div class="stat"><b>' + blow + "s</b><span>Worst single stage</span></div>";
    }
    function populateFilters() {
      var divSel = $("targa-division");
      var clsSel = $("targa-cls");
      if (!divSel) return;
      var names = Object.keys(DATA.divisions);
      if (!divSel.options.length) names.forEach(function (n) { divSel.add(new Option(n, n)); });
      if (!clsSel) return;
      var cur = clsSel.value;
      var classes = [];
      (DATA.divisions[divSel.value] || []).forEach(function (r) {
        if (r.cls && classes.indexOf(r.cls) === -1) classes.push(r.cls);
      });
      clsSel.innerHTML = '<option value="">All classes</option>' + classes.map(function (c) { return "<option>" + c + "</option>"; }).join("");
      if (classes.indexOf(cur) !== -1) clsSel.value = cur;
    }
    function syncViewButtons() {
      root.querySelectorAll("[data-targa-view]").forEach(function (btn) {
        btn.classList.toggle("active", btn.getAttribute("data-targa-view") === view);
      });
      var hint = $("targa-view-hint");
      if (hint) {
        hint.textContent = view === "raw"
          ? "Colour is gap to fastest on that stage. Position still follows penalty."
          : view === "pen"
            ? "Colour is penalty seconds. 0 is inside base time."
            : "Raw time on top · penalty underneath. Position follows penalty.";
      }
    }
    function render() {
      var title = $("targa-title");
      var stamp = $("targa-stamp");
      if (title) title.textContent = DATA.event + " — " + DATA.asOf;
      if (stamp) stamp.textContent = DATA.asOf;
      populateFilters();
      syncViewButtons();
      renderBoard();
      renderDetail();
      renderStats();
    }

    var tv = $("targa-tv");
    if (tv) tv.onclick = function () { root.classList.toggle("is-tv"); };
    var divSel = $("targa-division");
    if (divSel) divSel.onchange = function () { selected = null; render(); };
    var clsSel = $("targa-cls");
    if (clsSel) clsSel.onchange = render;
    var qEl = $("targa-q");
    if (qEl) qEl.oninput = render;
    root.querySelectorAll("[data-targa-view]").forEach(function (btn) {
      btn.onclick = function () { view = btn.getAttribute("data-targa-view"); render(); };
    });

    var divName = Object.keys(DATA.divisions)[0];
    if (!hasAnyRaw(DATA.divisions[divName] || [])) view = "pen";

    render();
  }

  function boot() {
    document.querySelectorAll(".targa-standings").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
